import './index.scss';

import React from 'react';

import Button from '../button';

const CartCustomize = props => {
  const { cartClick, cancelClick } = props;
  return (
    <div className="cart-customize">
      <p className="cart-customize__detail">
        This item has multiple customizations added.Proceed to cart to remove
        item.
      </p>
      <div classNam="cart-customize__button">
        <Button
          className="cart-customize__btn"
          content="Go to Cart"
          outlined
          size="is-medium"
          onClick={cartClick}
        />
        <Button
          className="cart-customize__btn"
          content="cancel"
          size="is-medium"
          onClick={cancelClick}
        />
      </div>
    </div>
  );
};

export default CartCustomize;
